<template>
  <div class="xs:container px-5 sm:px-10 pt-10 md:pt-[80px]">
    <div
      class="giveaway-bg text-white bg-blue-600 p-5 md:py-[65px] md:px-[60px] rounded-md"
    >
      <h2 class="font-cocogoose md:text-[30px] text-[20px] md:max-w-[400px]">
        {{ $i18n('general.GiveawayTitle')}}
      </h2>
      <p
        class="mt-1 md:mt-2.5 leading-[1.5] opacity-80 text-[12px] md:text-base max-w-[250px] md:max-w-[300px]"
        v-html="$i18n('general.GiveawayDescription')"
      >
      </p>
      <div
        role="button"
        tabindex="0"
        class="block mt-2.5 font-cocogoose text-[15px] overflow-hidden overflow-ellipsis hover:bg-blaze-orange-500 bg-orange-500 text-white rounded-md text-center cursor-pointer whitespace-nowrap max-w-min px-8 py-3"
        @keypress.stop.prevent="bookNow"
        @click.stop.prevent="bookNow"
      >
        <span>{{ $i18n('general.BookNow') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
  methods: {
    bookNow() {
      this.$store.dispatch('airportPicker/toggle');

      setTimeout(() => {
        window.scrollTo({
          behavior: 'smooth',
          top: 0,
        });
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.giveaway-bg {
  background-image: url('https://images.parkos.com/insecure/w:2400/h:800/plain/https://assets.parkos.com/assets/img/GiveawayBannerDesktop.png@webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 316.5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    display: block;
    min-height: 191px;
    background-image: url('https://images.parkos.com/insecure/w:800/h:400/plain/https://assets.parkos.com/assets/img/GiveawayBannerMobile.png@webp');
    background-position: right;

  }
}
</style>
